'use es6';

import { ROW_TREE_ATTRIBUTE } from 'layout-dnd-utils/constants/dndAreaDomConstants';
import { buildDndAreaRowSelector, getDndAreaCellElement, buildDndAreaRowTreeId, getDndAreaRowElementByIndex } from 'layout-dnd-utils/dom/dndAreaDomSelectors';
import { createDndAreaColumnElement } from 'layout-dnd-utils/render/renderColumns';
import { getElementBounds } from 'layout-dnd-utils/dom/bounds';
import { getComputedMargin } from 'layout-dnd-utils/dom/margin';
export const LS_MODULE_HOVER_OVERLAY = 'hs-ls-module-hover-overlay';
export const LS_UNEDITABLE_HOVER_OVERLAY = 'hs-ls-uneditable-hover-overlay';
export const LS_SOURCE_OF_CURRENT_DRAG = 'hs-ls-source-of-current-drag';
export const NON_LS_MODULE_HOVER_OVERLAY = 'hs-non-ls-module-hover-overlay';
export const NON_LS_MODULE_HOVER_OVERLAY_BLOCKED = 'hs-non-ls-module-hover-overlay__blocked';
export const NON_LS_MODULE_HOVER_OVERLAY_INLINE_EDITABLE = 'hs-non-ls-module-hover-overlay__inline-editable';
export const NON_LS_MODULE_HOVER_OVERLAY_GLOBAL_GROUP = 'hs-non-ls-module-hover-overlay__global-group';
export const NON_LS_MODULE_HOVER_OVERLAY_EMBED = ' hs-non-ls-module-hover-overlay__global-group hs-non-ls-module-hover-overlay__embed';
export const NON_LS_MODULE_HOVER_OVERLAY_WITHOUT_ACCESS = 'hs-non-ls-module-hover-overlay__without-access';
export const NON_LS_MODULE_HOVER_OVERLAY_RICH_TEXT_WITH_MODULES_WITHOUT_ACCESS = 'hs-non-ls-module-hover-overlay__rich_text_with_modules_without-access';
export const buildLayoutSectionEditorOnlyUniqueRowSelector = (parentName, rowName) => {
  return `[${ROW_TREE_ATTRIBUTE}="${buildDndAreaRowTreeId(parentName, rowName)}"]`;
};
export const buildRenderCompatibleRowChildDomSelector = treeNode => {
  const rendererRowName = treeNode.getRendererCompatibleRowName();
  return `${buildDndAreaRowSelector(rendererRowName)} > .row-fluid`;
};
export const getRowInnerWrapperElement = rowElement => {
  return Array.from(rowElement.childNodes).filter(el => el.nodeType === 1 && el.classList.contains('row-fluid'))[0];
};
export const areBoundsAndMarginEqual = (dimensions1, dimensions2) => {
  if (!dimensions1 || !dimensions1.bounds || !dimensions2.margin || !dimensions2 || !dimensions2.bounds || !dimensions2.margin) {
    return false;
  }
  for (const key of ['top', 'bottom', 'left', 'right', 'height', 'width']) {
    if (dimensions1.bounds[key] !== dimensions2.bounds[key]) {
      return false;
    }
  }
  for (const key of Object.keys(dimensions1.margin)) {
    if (dimensions1.margin[key] !== dimensions2.margin[key]) {
      return false;
    }
  }
  return true;
};
export const getElementBoundsAndMargin = element => {
  return {
    bounds: getElementBounds(element, {
      applyScrollOffset: true
    }),
    margin: getComputedMargin(element)
  };
};
export const getLayoutSectionRowBoundsByIndex = (parentColumnId, rowIndex) => {
  const rowElement = getDndAreaRowElementByIndex(parentColumnId, rowIndex);
  return getElementBounds(rowElement, {
    applyScrollOffset: true
  });
};
export const getLayoutSectionColumnBounds = id => {
  const layoutElement = getDndAreaCellElement(id);
  return getElementBounds(layoutElement, {
    applyScrollOffset: true
  });
};
export const createLayoutSectionModuleElement = (moduleId, moduleHtml, moduleParams) => {
  const moduleElement = createDndAreaColumnElement({
    treeId: moduleId,
    cellParams: moduleParams
  });
  moduleElement.innerHTML = moduleHtml;
  return moduleElement;
};